import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlinePadlock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M9.544 4.819H2.456a.79.79 0 0 0-.787.787v4.725c0 .435.352.788.787.788h7.088a.79.79 0 0 0 .787-.788V5.606a.787.787 0 0 0-.787-.787"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M8.756 4.819V3.637a2.756 2.756 0 1 0-5.512 0V4.82M6 8.362a.394.394 0 1 0 0-.787.394.394 0 0 0 0 .787"
    />
  </svg>
);
export default SvgStreamlinePadlock;
